var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VuePopper',{attrs:{"options":_vm.popperOptions}},[_c('div',{staticClass:"popper"},[_vm._v(_vm._s(_vm.message))]),_c('img',{staticClass:"img-fluid",attrs:{"slot":"reference","src":require("../assets/img/question_mark.png"),"alt":"More Info"},slot:"reference"})])
}
var staticRenderFns = []

export { render, staticRenderFns }